import React from "react";
import AUTHOR from "../data/author";

export function AuthorByline({ date, readTime }) {
    return (
        <div className="flex items-center gap-3 text-sm" data-testid="author-byline">
            <img src={AUTHOR.photoSmall} alt={AUTHOR.name} className="w-9 h-9 rounded-full object-cover border border-black/10" />
            <div className="leading-tight">
                <div className="ui-heading font-semibold text-ink">{AUTHOR.name}</div>
                <div className="text-xs text-ink-muted">
                    {date && <span>{date}</span>}
                    {date && readTime && <span> · </span>}
                    {readTime && <span>{readTime}</span>}
                </div>
            </div>
        </div>
    );
}

export function AuthorBioCard() {
    return (
        <aside className="border border-black/10 bg-paper p-6 flex gap-5 items-start" data-testid="author-bio-card">
            <img src={AUTHOR.photo} alt={AUTHOR.name} className="w-20 h-20 rounded-full object-cover border border-black/10 shrink-0" />
            <div>
                <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted">/ written by</div>
                <h3 className="font-display font-black tracking-tighter text-xl mt-1">{AUTHOR.name}</h3>
                <p className="text-xs text-ink-muted mt-1">{AUTHOR.role} · {AUTHOR.location}</p>
                <p className="text-sm text-ink-soft mt-3 leading-relaxed">{AUTHOR.bio}</p>
            </div>
        </aside>
    );
}

export default AuthorByline;
